import { Card } from "@/components/ui/card";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

export type NewRecipeTileProps = Readonly<{
  recipeBoxId: string;
}>;

export const NewRecipeTile = ({ recipeBoxId }: NewRecipeTileProps) => {
  return (
    <Link
      to={`/add-recipe?recipeBoxId=${recipeBoxId}`}
      className="group hidden h-full w-full rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 sm:block"
      aria-label="Add a new recipe"
    >
      <Card className="flex h-full w-full flex-col border border-dashed border-muted-foreground/40 bg-card text-muted-foreground transition hover:border-muted-foreground hover:text-foreground hover:shadow-md">
        <div className="flex aspect-square items-center justify-center">
          <Plus className="h-8 w-8 transition group-hover:scale-105" strokeWidth={1.5} />
        </div>
        <div className="p-1.5 text-center">
          <span className="font-headline text-sm font-medium">New Recipe</span>
        </div>
      </Card>
    </Link>
  );
};

